import React, { Component } from "react"
import config from "react-global-configuration"
import { getContentData } from "../../helpers/bookingHelper"
import { getCssLegend } from "../../helpers/bookingHelper"

class ReceiptHowto extends Component {
  state = {
    isActive: true,
  }

  render() {
    if (!this.props.bookingResult) return null

    const { content } = this.props
    const { booking, activeBookingExtraProducts, carPark, product } = this.props.bookingResult
    const contentData = getContentData(carPark, product, content)
    const legend = getCssLegend(carPark.name, product.name)

    const textKeys = config.get("textKeys.receipt.howTo") || {}

    const normalDriveIn = legend === "budget" || legend === "standard" || legend === "standardplus" || legend === "direct"
    const weParkYouFly = legend === "weparkyoufly"
    const hasCarCareProduct = !!activeBookingExtraProducts.find((e) => !e.product.showBookingPage)

    return (
      <section className="deck deck--white">
        <div className="w--wider">
          <div className="flow-banner ">
            <header>
              <h3>{textKeys?.header || "Sådan gør du"}</h3>
              <p>
                {textKeys?.subHeader ||
                  "Du tjekker ind og ud af parkeringsanlægget med din QR kode, som du også har fået tilsendt i bekræftelsesmailen. QR-koden fungerer som ordrebekræftelse og adgangskort og er derfor det eneste, du behøver have med, når du ankommer."}
              </p>
            </header>
            <ul className="flow-banner__steps">
              {/* Flow Step 1 */}
              <li>
                <div className="image">
                  <img src={textKeys?.flow1Image || "/Static/flow-3.svg"} alt="" />
                </div>
                <span
                  dangerouslySetInnerHTML={{ __html: textKeys?.flow1Text || "Tjek ind og ud af parkeringsanlægget med din tilsendte QR-kode" }}
                ></span>
              </li>

              {/* Flow Step 2 */}
              <li>
                <div className="image">
                  <img src={contentData?.flowImage || "/Static/flow-1.svg"} alt="" />
                </div>
                <span dangerouslySetInnerHTML={{ __html: contentData?.flowText || "test fallback text" }}></span>
              </li>

              {/* Flow Step 3 */}
              {normalDriveIn ? (
                !hasCarCareProduct ? (
                  <li>
                    <div className="image">
                      <img src={textKeys?.flow3Container?.withoutService?.image || "/Static/flow-2.svg"} alt="" />
                    </div>
                    <span dangerouslySetInnerHTML={{ __html: textKeys?.flow3Container?.withoutService?.text || "Du er klar til at flyve!" }}></span>
                  </li>
                ) : (
                  <li>
                    <div className="image">
                      <img src={textKeys?.flow3Container?.withService?.image || "/Static/flow-illustrationer-10.svg"} alt="" />
                    </div>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: textKeys?.flow3Container?.withService?.text || "Du har bestilt bilpleje, husk at aflever nøglen!",
                      }}
                    ></span>
                  </li>
                )
              ) : (
                ""
              )}
              {weParkYouFly ? (
                !hasCarCareProduct ? (
                  <li>
                    <div className="image">
                      <img src={textKeys?.flow3Container?.weParkYouFlyWithoutService?.image || "/Static/flow-2.svg"} alt="" />
                    </div>
                    <span
                      dangerouslySetInnerHTML={{ __html: textKeys?.flow3Container?.weParkYouFlyWithoutService?.text || "Du er klar til at flyve!" }}
                    ></span>
                  </li>
                ) : (
                  <li>
                    <div className="image">
                      <img src={textKeys?.flow3Container?.weParkYouFlyWithService?.image || "/Static/flow-illustrationer-11.svg"} alt="" />
                    </div>
                    <span
                      dangerouslySetInnerHTML={{ __html: textKeys?.flow3Container?.weParkYouFlyWithService?.text || "Du har bestilt bilpleje!" }}
                    ></span>
                  </li>
                )
              ) : (
                ""
              )}
            </ul>
            <footer></footer>
          </div>
        </div>
      </section>
    )
  }
}
export default ReceiptHowto
